export class Timer {
	public elapsed: number = 0;

	public tick(deltaMS: number) {
		this.elapsed += deltaMS;
	}

	public reset() {
		this.elapsed = 0;
	}
}
